import React from "react";
import {
  Avatar,
  Divider,
  Grid,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import Logout from "../Logout.jsx";
import UserProfile from "./components/buttons/UserProfile.jsx";
import { useTranslation } from "react-i18next";
import ProfilePicture from "./components/ProfilePicture.jsx";
import ThemeSwitch from "../ThemeSwitch.jsx";
import usePrimaryColor from "../../hooks/usePrimaryColor.jsx";
import useUser from "../../hooks/useUser.jsx";
import LanguageSwitcher from "../LanguageSwitcher.jsx";
import ThemeButton from "../buttons/ThemeButton.jsx";
import { isNullOrEmpty } from "../../utils/Functions.jsx";

export default function UserAvatar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { profile } = useUser();
  const { t } = useTranslation();
  const color = usePrimaryColor();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const displayName = isNullOrEmpty(profile?.email)
    ? profile.username
    : profile?.email;
  return (
    <React.Fragment>
      <Avatar
        sx={{
          bgcolor: color,
          color: "white",
          border: "1px solid white",
          cursor: "pointer",
        }}
        onClick={handleClick}
        data-testid="header.user-menu.avatar"
      >
        {profile.initials}
      </Avatar>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            width: 315,
            borderRadius: 2,
            boxShadow: 3,
          },
        }}
      >
        <Stack mt={3} mb={3} direction={"column"} spacing={2}>
          <ProfilePicture />
          <Typography
            sx={{ p: 1, wordBreak: "break-all" }}
            textAlign={"center"}
          >
            {String(displayName)}
          </Typography>
          <Divider />
          <Grid p={1} container alignItems="center">
            <Grid item xs={9}>
              <Typography variant="button">{t("Theme")}</Typography>
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="flex-end">
              <ThemeButton />
            </Grid>
          </Grid>
          <Divider />
          <Grid p={1} container alignItems="center">
            <Typography variant="button">{t("Language")}</Typography>
            <LanguageSwitcher
              showExpanded={false}
              testIdPrefix="header.user-menu.language"
            />
          </Grid>

          <Divider />
          {/* Body of avatar popover, all links and buttons go here */}
          <UserProfile handleClose={handleClose} />
          <Logout />
        </Stack>
      </Popover>
    </React.Fragment>
  );
}
